export const SIGNALR_MESSAGE_TYPES = {
  NOTIFICATION: "Notification",

  CORE_SECURITY_AUDITLOGS: "CORE_SECURITY_AUDITLOGS",
  CORE_LOGIN: "CORE_LOGIN",

  NAS_TRANSACTIONS_CHECKINS: "NAS_TRANSACTIONS_CHECKINS",
  NAS_TRANSACTIONS_ADD_CLINIC_QUE: "NAS_TRANSACTIONS_ADD_CLINIC_QUE",
  NAS_TRANSACTIONS_REMOVE_CLINIC_QUE: "NAS_TRANSACTIONS_REMOVE_CLINIC_QUE",
  NAS_TRANSACTIONS_ADD_GUIDANCE_QUE: "NAS_TRANSACTIONS_ADD_GUIDANCE_QUE",
  NAS_TRANSACTIONS_REMOVE_GUIDANCE_QUE: "NAS_TRANSACTIONS_REMOVE_GUIDANCE_QUE",

  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS: "GLOBO_TRANSACTIONS_DOCTORENROLLMENTS",
  GLOBO_TRANSACTIONS_LOAREQUESTS: "GLOBO_TRANSACTIONS_LOAREQUESTS",
  GLOBO_TRANSACTIONS_ORDERREQUESTS: "GLOBO_TRANSACTIONS_ORDERREQUESTS",
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS: "GLOBO_TRANSACTIONS_PATIENTENROLLMENTS",
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS: "GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS"
};
